import {get} from '../utils/httpUtils';

export const services = {
    getAttentions: (body) => get('atentions', body),
    getAffiliates: (body) => get('attentions/affiliates', body),
    // [MODULE SERVICES] NEW SERVICE
};
